import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PublicLegalInfoComponent } from './info/info.component';
import { PublicLegalTermsComponent } from './terms/terms.component';

const routes: Routes = [
    {
        path: 'public/legal',
        children: [
            { path: ':businessId/info', component: PublicLegalInfoComponent },
            { path: ':businessId/terms', component: PublicLegalTermsComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PublicLegalRoutingModule { }
